import { atom } from "jotai";
import { PRODUCT_NAV_WIDTH } from "@zapier/canvas-constants";
import { calculateSidebarWidth } from "../utils/calculateSidebarWidth";

export const SUMMARY = "summary" as const;

export type SideBarSelected = typeof SUMMARY | "devTools" | null;

// Private atom for internal state management
// ⚠️ DO NOT USE THIS DIRECTLY - use sideBarSelectedAtom instead
const sideBarSelectedPrivateAtom = atom<SideBarSelected>(null);

sideBarSelectedPrivateAtom.debugLabel = "sideBarSelectedPrivateAtom";

/**
 * Public atom with getter/setter functionality
 *
 * Note: When opening a sidebar item from a component, you should also close the copilot:
 * Use OUR OWN useCopilotDrawerState - NOT the one from ai-toolkit/client
 * const [, setIsCopilotOpen] = useCopilotDrawerState();
 * setIsCopilotOpen(false);
 * set(sideBarSelectedAtom, selectedItem);
 */
export const sideBarSelectedAtom = atom(
  (get) => get(sideBarSelectedPrivateAtom),
  (_, set, newValue: SideBarSelected) => {
    set(sideBarSelectedPrivateAtom, newValue);

    // See useCopilotDrawerState for the same code for copilot
    const isSidebarOpen = newValue !== null;
    set(sideBarWidthAtom, calculateSidebarWidth(isSidebarOpen));
  },
);

sideBarSelectedAtom.debugLabel = "sideBarSelectedAtom";

// Atom to track the sidebar width for other components to use
export const sideBarWidthAtom = atom<number>(PRODUCT_NAV_WIDTH);

sideBarWidthAtom.debugLabel = "sideBarWidthAtom";
